import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { ribbon } from '../../styles/colors'
import { resolveBlock } from './utils';

class Block extends React.Component {

	state = {
	
	}
	
	render() {
		const { layout, sectionIndex, lastSection, lastBlock, media, block_type } = this.props;
		const BlockLayout = resolveBlock(layout);
		
		return (
			<Wrapper
				className={layout}
				layout={layout}
				blockType={block_type}
				blockProps={this.props}
				styles={BlockLayout && BlockLayout.wrapper}
				sectionIndex={sectionIndex}
				lastSection={lastSection}
				lastBlock={lastBlock}
				media={media}
			>
				{BlockLayout && (
					<BlockLayout {...this.props}/>
				)}
			</Wrapper>
		)
	}
}

const Wrapper = styled.div`
    width: 100%;
	margin-bottom: 10rem;

	&:first-child {
		padding-top: 15rem;
	}

	&:last-child {
		margin-bottom: 15rem;
	}
	
	/* Block specific container styles */

	${props => {
		if (props.styles) return props.styles
	}}

	/* Controlled z-index */

	position: relative;
	z-index: ${props => props.sectionIndex};

	${props => {
		if (props.lastSection && props.lastBlock && props.blockType == 'single_media' && props.media[0].layout_type == 'fullwidth') return css`
			margin-bottom: 0 !important;
		`
 	}}
`

export default Block



// WEBPACK FOOTER //
// ./src/components/Block/Block.js